import { useState } from 'react'
import {
    MoreInfoText,
    ShowMoreInfo,
} from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { slideDown } from '@/src/common/animations'
import RecommendedItemsWithoutSearch from '@/src/modules/pg-plus/content/recommendations/RecommendedItemsWithoutSearch'
import {
    GiftIdeasWrapper,
    MarginTopWrapper,
} from '@/src/modules/pg-plus/content/recommendations/StyledComponents'
import GiftIdea from '@/src/modules/pg-plus/content/gift-ideas/GiftIdea'

type TGiftIdeaProps = {
    image1: string
    image2: string
    trendingItems: [] | null
    hasPartner: boolean
}

const GiftIdeasAndRecommendations = ({
    image1,
    image2,
    trendingItems,
    hasPartner,
}: TGiftIdeaProps) => {
    const hideGiftIdeas = true;// hiding for this partner set up. Heading for this is in RecommendedItemsWithoutSearch.tsx
    const [showMoreInfo, setShowMoreInfo] = useState<boolean>(true)

    return (
        <MarginTopWrapper>
            <ShowMoreInfo onClick={() => setShowMoreInfo(!showMoreInfo)}>
                <MoreInfoText>You might also like:</MoreInfoText>
                <FontAwesomeIcon
                    icon={showMoreInfo ? faAngleUp : faAngleDown}
                />
            </ShowMoreInfo>
            {showMoreInfo && (
                <div
                    style={{
                        animation: showMoreInfo
                            ? `${slideDown} 0.5s ease-in-out`
                            : 'none',
                    }}
                >
                    <RecommendedItemsWithoutSearch
                        showGiftIdeasText={!hasPartner}
                        trendingItems={trendingItems}
                        hasPartner={hasPartner}
                    />
                    {/*don't show visa recommendations in partner flow*/}
                    {!hasPartner && !hideGiftIdeas && (
                        <GiftIdeasWrapper>
                            <GiftIdea
                                image={image1}
                                description={'Virtual Visa Card'}
                                url={'/virtual-visa-gift-cards'}
                                type={'virtual'}
                                brandName={'Visa'}
                            />
                            <GiftIdea
                                image={image2}
                                description={'Custom Visa Gift Card'}
                                url={'/personalized-visa-gift-card'}
                                type={'plastic'}
                                brandName={'Visa'}
                            />
                        </GiftIdeasWrapper>
                    )}
                </div>
            )}
        </MarginTopWrapper>
    )
}

export default GiftIdeasAndRecommendations
